import Component from '../core';

const TRANSITION_DURATION = 700;
export default class DarkToggle extends Component {
  setup() {
    this.state = {
      isDark: false,
    };

    this.refs = {
      appRef: null,
      hoverRef: null,
    };

    super.setup();
  }

  hydrate() {
    this.addEvent('click', this.idSelector, () => {
      this.setState({ isDark: !this.state.isDark });

      this.$target.classList.toggle('hoverEnabled', false);

      clearTimeout(this.refs.hoverRef);
      this.refs.hoverRef = setTimeout(() => {
        this.$target.classList.toggle('hoverEnabled', true);
      }, TRANSITION_DURATION);
    });

    this.$target.classList.toggle('hoverEnabled', true);

    this.refs.appRef = document.querySelector('#app');

    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      this.state.isDark = true;
    }

    super.hydrate();
  }

  render() {
    this.setDark();

    super.render();
  }

  setDark() {
    this.refs.appRef.classList.toggle('dark', this.state.isDark);
    this.$target.classList.toggle('dark', this.state.isDark);
  }
}
